import React, { useState } from 'react'
import { useRegularization } from '../../../Hooks/Features/HrLens/useRegularization'
import { AgGridReact } from '@ag-grid-community/react'
import { SkeletonDataTable } from '../../../components/Loader/Loader'
import CommanDialog from '../../../components/CommonCompo/CommanDialog/CommanDialog'
import { useCommon } from '../../../Hooks/Common/useCommon'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Regularization = () => {
    const { tagRef, colDef, regularizationList, loader, status, setStatus, confirmationPopup, handleRequest, setConfirmationPopup, handleDelete, getRegularizationList } = useRegularization({})
    const { checkPermission } = useCommon();
    const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);

    return (
        <div ref={() => checkPermission("Regularization", tagRef)}>
            <div ref={tagRef} id='{"tabname": "regularization", "data": "regularization_tab"}'>
                <div className="d-flex align-items-center justify-content-between gap-3 w-100 mt-2">
                    <div className="d-flex align-items-center gap-2 flex-grow-1">
                    </div>
                    <div className="d-flex justify-content-end gap-2">
                        <button className="sk-btn sk-btn-primary rounded" onClick={() => getRegularizationList(status)} title="Refresh">
                            <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
                        </button>
                        <button className="sk-btn sk-btn-primary rounded" onClick={() => setShowFiltersDrawer(true)} title="Filters">
                            <FontAwesomeIcon icon="fa-solid fa-filter" />
                        </button>
                    </div>
                </div>
                <div className="ag-theme-alpine mt-2" style={{ height: "calc(100vh - 110px)" }}>
                    {loader ? <div style={{ height: "100%" }}><SkeletonDataTable numSkeletons={21} /></div> :
                        <AgGridReact columnDefs={colDef} rowData={regularizationList} headerHeight={60} rowHeight={30} autoGroupColumnDef={{ pinned: "left", hide: true, width: 200 }} groupDefaultExpanded="-1" />
                    }
                </div>

                {/* Right Panel Filters Drawer */}
                <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
                    <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
                        <div className="sk-drawer-header">
                            <h5 className="sk-drawer-title">Filters</h5>
                            <div className="d-flex align-items-center gap-2">
                                <button className="sk-drawer-clear-btn" onClick={() => {
                                    setStatus("P");
                                }}>Clear All</button>
                                <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                                    <FontAwesomeIcon icon="fa-solid fa-xmark" />
                                </button>
                            </div>
                        </div>
                        <div className="sk-drawer-body">
                            <div className='d-flex flex-column gap-4'>
                                {/* Status Filter */}
                                <div className="sk-drawer-filter-group">
                                    <div className="task-list-filter-label">Status</div>
                                    <div className='sk-segment-control mb-3'>
                                        <button 
                                            type="button" 
                                            className={`sk-segment-btn ${status === 'P' ? 'active' : ''}`}
                                            onClick={() => setStatus("P")}
                                        >
                                            Pending
                                        </button>
                                        <button 
                                            type="button" 
                                            className={`sk-segment-btn ${status === 'A' ? 'active' : ''}`}
                                            onClick={() => setStatus("A")}
                                        >
                                            Approved
                                        </button>
                                        <button 
                                            type="button" 
                                            className={`sk-segment-btn ${status === 'R' ? 'active' : ''}`}
                                            onClick={() => setStatus("R")}
                                        >
                                            Rejected
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="sk-drawer-footer">
                            <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
                                getRegularizationList(status);
                                setShowFiltersDrawer(false);
                            }}>Apply Filters</button>
                        </div>
                    </div>
                </div>
                <CommanDialog
                    visible={confirmationPopup?.show}
                    message={confirmationPopup?.type === "delete" ? "Are you sure you want to delete this request?" : `Are you sure you want to ${confirmationPopup?.value === "A" ? "approve" : "reject"} the regularization?`}
                    handleClose={() => setConfirmationPopup({ show: false, data: null })}
                    handleFun={() => {
                        if (confirmationPopup?.type === "delete") {
                            handleDelete(confirmationPopup?.data)
                        } else {
                            handleRequest(confirmationPopup?.value, confirmationPopup?.data)
                        }

                    }}
                />
            </div>
        </div>
    )
}

export default Regularization